import React from "react";
import { Button, dialog, Input, InputJson } from "../../nq-component";
import { v4 as uuidv4 } from "uuid";
import {
  findObjectUseCase,
  getObjectUseCase,
  upsertUseCase,
} from "../../usecases/object";
import withRouter from "../../withRouter";
import BaseFormPage from "../../base/BaseFormPage";
import FormFactory from "../../components/FormFactory";
import ApplicationFormPresenter from "./ApplicationFormPresenter";
import Navigation from "../../components/Navigation";
import { Link } from "react-router-dom";
import schemaPersonalForm1 from "./schemas/schemaPersonalForm1.json";
import schemaContactPerson from "./schemas/schemaContactPerson.json";
import schemaContactPersonAddress from "./schemas/schemaContactPersonAddress.json";
import schemaIdForm from "./schemas/schemaIdForm.json";
import schemaEmployment from "./schemas/schemaEmployment.json";
import schemaCharacterRef from "./schemas/schemaCharacterRef.json";
import schemaElementaryForm from "./schemas/schemaElementaryForm.json";
import schemaHSForm from "./schemas/schemaHSForm.json";
import schemaColForm from "./schemas/schemaColForm.json";
import schemaDocForm from "./schemas/schemaDocForm.json";
import schemaOtherDocs from "./schemas/schemaOtherDocs.json";
import schemaPresentAddress from "./schemas/schemaPresentAddress.json";
import schemaPermanentAddress from "./schemas/schemaPermanentAddress.json";
import InputFactory from "../../components/InputFactory";
import { footer, image, select } from "framer-motion/client";
import { parse } from "papaparse";
import { signOutUseCase } from "../../usecases/user";
import RelationForm from "../../components/RelationForm";
import { saveFileUseCase, saveImageUseCase } from "../../usecases/file";
import DialogWarning from "./components/DialogWarning";
import schemaPersonalForm2 from "./schemas/schemaPersonalForm2.json";

class ApplicationFormPage extends BaseFormPage {
  constructor(props) {
    super(props);
    this.presenter = new ApplicationFormPresenter(
      this,
      upsertUseCase(),
      signOutUseCase(),
      findObjectUseCase()
    );
    this.state = {
      object: {},
      isSubmitting: false,
      advanced: false,
      isAddressSame: false,
      addressSameApplicant: false,
      employmentForm: [],
      selectedjob: "",
      whereLGSSee: "select",
      recruiters: [],
      isWalkIn: true,
      image: "",
      age: 0,
      employers: [{ id: crypto.randomUUID() }],
      characterref: [{ id: crypto.randomUUID() }],
      selectedOptions: {
        tor: false,
        reportCard: false,
        diploma: false,
      },
      uploadedFiles: {
        coe: null,
        reportCard: null,
        diploma: null,
        graduationCertificate: null,
      },
      selectedNames: [],
      isschoolRecord: false,
    };
  }
  formSubmit(e) {
    e.preventDefault();
    const { image, uploadedFiles } = this.state;
    this.setState({ isSubmitting: true });

    const hasUploadedFiles = Object.values(uploadedFiles).some(
      (file) => file !== null && file !== undefined
    );

    if (!hasUploadedFiles) {
      this.showModal("Note", "Please upload at least one school record.");
      this.setState({ isSubmitting: false });
      return;
    }

    const isValid = this.presenter.validateInputs();
    if (!isValid) {
      this.showModal("Note", "Please upload all the required documents.");
      this.setState({ isSubmitting: false });
      return;
    }

    if (!image) {
      this.showModal(
        "Note",
        "Please upload an image of yourself before submitting."
      );
      this.setState({ isSubmitting: false });
      return;
    }

    this.presenter.submitForm();
  }

  showModal(title, message) {
    dialog.fire({
      html: <DialogWarning title={title} message={message} />,
      footer: false,
    });
  }

  onChangePersonal(value, field) {
    this.presenter.onChangePersonal(value, field);
    switch (field) {
      case "diploma":
        this.setState((prevState) => ({
          uploadedFiles: {
            ...prevState.uploadedFiles,
            diploma: value,
          },
        }));
        break;

      case "tor":
        this.setState((prevState) => ({
          uploadedFiles: {
            ...prevState.uploadedFiles,
            tor: value,
          },
        }));
        break;

      case "reportCard":
        this.setState((prevState) => ({
          uploadedFiles: {
            ...prevState.uploadedFiles,
            reportCard: value,
          },
        }));
        break;

      case "graduationCertificate":
        this.setState((prevState) => ({
          uploadedFiles: {
            ...prevState.uploadedFiles,
            graduationCertificate: value,
          },
        }));
        break;

      case "birthDate":
        const today = new Date();
        const birthDate = new Date(value);
        const age = today.getFullYear() - birthDate.getFullYear();
        const monthDifference = today.getMonth() - birthDate.getMonth();

        const calculatedAge =
          monthDifference < 0 ||
          (monthDifference === 0 && today.getDate() < birthDate.getDate())
            ? age - 1
            : age;

        if (calculatedAge < 0) {
          this.showModal(
            "Invalid Birth Date",
            "The birth date you entered is in the future. Please enter a valid birth date."
          );
          return;
        }

        this.setState({ age: calculatedAge });
        this.presenter.onChangePersonal(calculatedAge, "age");
        break;

      case "positionApplied":
        const selectedJobs = localStorage.getItem("selectedJobs");
        try {
          if (selectedJobs && selectedJobs.length > 0) {
            const parsedData = JSON.parse(selectedJobs);
            const matchedJobs = parsedData.filter(
              (job) => job?.positionTitle === value
            );

            const index = 0;
            const jobByIndex = matchedJobs[index] || matchedJobs[0];

            const deploymentType = jobByIndex?.deploymentType || "N/A";

            this.presenter.onChangePersonal(value, field);
            this.presenter.onChangePersonal(deploymentType, "deploymentType");

            this.setState({
              deploymentType,
            });

            console.log("Selected Deployment Type:", deploymentType);
          } else {
            this.navigateTo("/jobportal");
          }
        } catch (error) {
          console.error(error);
          this.navigateTo("/jobportal");
        }
        break;

      default:
        break;
    }
  }

  onChangeRecruiter(event) {
    this.presenter.onChangeRecruiter(event);
  }

  onChangeEmployment(value, field) {
    this.presenter.onChangeEmployment(value, field);
  }

  onChangecharacteref(value, field) {
    this.presenter.onChangecharacteref(value, field);
  }

  // getCollectionName() {
  //   return "online_applicants";
  // }

  onClickAdvance() {
    this.setState({ advanced: !this.state.advanced });
  }

  onChangeObject(object) {
    this.presenter.onChangeObject(object);
  }

  toggleCheckbox(event) {
    const isChecked = event.target.checked;
    this.setState({ isAddressSame: isChecked });
  }

  toggleCheckboxContact(event) {
    const isChecked = event.target.checked;
    this.setState({ addressSameApplicant: isChecked });
  }

  onChangeLGS(value, field) {
    this.setState({ whereLGSSee: value });
    this.presenter.onChangePersonal(value, field);
  }

  addEmployer = () => {
    this.setState((prevState) => ({
      employers: [...prevState.employers, { id: crypto.randomUUID() }],
    }));
  };

  addCharacterRef = () => {
    this.setState((prevState) => ({
      characterref: [...prevState.characterref, { id: crypto.randomUUID() }],
    }));
  };

  removeEmployer = (id) => {
    if (this.state.employers.length > 1) {
      this.setState((prevState) => ({
        employers: prevState.employers.filter((employer) => employer.id !== id),
      }));
      this.presenter.removeEmployment(id);
    }
  };
  removeCharacterRef = (id) => {
    if (this.state.characterref.length > 1) {
      this.setState((prevState) => ({
        characterref: prevState.characterref.filter(
          (character) => character.id !== id
        ),
      }));
      this.presenter.removeCharacterRef(id);
    }
  };

  handleCheckboxChange = (event) => {
    const { name, checked, title } = event.target;

    this.setState((prevState) => {
      let updatedNames = [...prevState.selectedNames];

      if (checked) {
        updatedNames.push(title);
      } else {
        updatedNames = updatedNames.filter((item) => item !== title);
      }

      return {
        selectedOptions: {
          ...prevState.selectedOptions,
          [name]: checked,
        },
        selectedNames: updatedNames,
        uploadedFiles: {
          ...prevState.uploadedFiles,
          [name]: checked ? prevState.uploadedFiles[name] : null,
        },
      };
    });
  };

  toggleDropdown() {
    this.setState((prevState) => ({
      isschoolRecord: !prevState.isschoolRecord,
    }));
  }

  generateReferenceNumber = () => {
    const hash = uuidv4().replace(/\D/g, "");
    return hash.slice(0, 11);
  };

  goBack() {
    this.presenter.removeSelectedJobs();

    const history = window.history;
    const previousPage = document.referrer;

    if (previousPage.includes("/signin")) {
      history.go(-2);
    } else {
      history.back();
    }
  }

  componentWillUnmount() {
    localStorage.removeItem("selectedJobs");
  }

  render() {
    const {
      isAddressSame,
      addressSameApplicant,
      whereLGSSee,
      selectedOptions,
      uploadedFiles,
      selectedNames,
      isschoolRecord,
      isSubmitting,
      object,
      image,
      employers,
      characterref,
      recruiters,
      age,
    } = this.state;

    const selectedJobs = localStorage.getItem("selectedJobs");
    const selectJobs = [];
    try {
      if (selectedJobs.length > 0) {
        const parsedData = JSON.parse(selectedJobs);

        parsedData.map((object) => {
          selectJobs.push(object?.positionTitle);
        });
      } else {
        this.navigateTo("/jobportal");
      }
    } catch (error) {
      this.navigateTo("/jobportal");
      console.log(error);
    }
    const user = this.getCurrentUser();
    console.log(user);
    return (
      <>
        <div
          style={{ marginTop: `3.5rem`, overflowY: `hidden` }}
          className="py-5 px-2 p-md-5"
        >
          <div className="d-flex flex-column">
            <div className="d-flex gap-4">
              <p className="cursor-pointer" onClick={this.goBack.bind(this)}>
                <i
                  class="bi bi-arrow-left fs-4"
                  style={{ color: `#303030CC` }}
                ></i>
              </p>
              <h1 className="fs-2 fw-bold" style={{ color: `#D18237` }}>
                Application Form
              </h1>
            </div>
            <div className="bg-white p-4 rounded-3 d-flex flex-column gap-0">
              <form
                onSubmit={this.formSubmit.bind(this)}
                disabled={isSubmitting}
              >
                <p className="fs-5 fw-bold p-0 m-0">Instructions:</p>
                <p className="p-0 m-0">
                  1. Answer ALL questions completely and accurately.
                </p>
                <p className="p-0 m-0">
                  2. Provide all information to the best of your knowledge.
                </p>
                <div className="d-flex w-100 flex-column flex-column-reverse flex-md-row justify-content-between">
                  <div className="d-flex flex-column col-md-4 col-lg-3 align-items-start mt-3 gap-2">
                    <div className="d-flex flex-column gap-2 w-100">
                      <b>Where did you see LGS?</b>
                      <InputFactory
                        type="Enum"
                        options={[
                          "Walk-in",
                          "Social Media",
                          "Recruiter",
                          "Word of Mouth",
                        ]}
                        required
                        className="form-control bg-light-subtle p-2"
                        placeholder="Select"
                        field="seeLGS"
                        onChange={this.onChangeLGS.bind(this)}
                      />
                      {whereLGSSee === "Recruiter" ? (
                        <div>
                          <select
                            name="recruiter"
                            required
                            className="form-control bg-light-subtle p-2"
                            onChange={this.onChangeRecruiter.bind(this)}
                          >
                            <option selected disabled>
                              Select
                            </option>
                            {recruiters.map((recruiter, index) => (
                              <option key={index} value={recruiter?.id}>
                                {recruiter.employee?.firstName +
                                  ` ${recruiter.employee?.lastName}`}
                              </option>
                            ))}
                          </select>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="d-flex flex-column w-100">
                      <p className="text-muted m-0 p-0">
                        Position/s Applied for:
                      </p>
                      <p className="m-0 p-0">
                        {selectJobs.map((job, index) => {
                          return index === selectJobs.length - 1
                            ? job
                            : job + ", ";
                        })}
                      </p>
                      <InputFactory
                        type="Enum"
                        options={selectJobs}
                        required
                        className="form-control bg-light-subtle p-2"
                        placeholder="Select"
                        field="positionApplied"
                        onChange={this.onChangePersonal.bind(this)}
                      />
                    </div>

                    <div className="mt-2 w-100">
                      <b>Do you have any relative in:</b>
                      <div className="mt-2">
                        <label className="form-label fs-sm">LGS</label>
                        <InputFactory
                          type="Enum"
                          options={["Yes", "No"]}
                          required
                          className="form-control bg-light-subtle p-2"
                          placeholder="Select"
                          field="relativeLGS"
                          onChange={this.onChangePersonal.bind(this)}
                        />
                      </div>
                      <div>
                        <label className="form-label fs-sm">Client</label>
                        <InputFactory
                          type="Enum"
                          options={["Yes", "No"]}
                          required
                          className="form-control bg-light-subtle p-2"
                          placeholder="Select"
                          field="relativeClient"
                          onChange={this.onChangePersonal.bind(this)}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="mt-3 col-lg-6">
                    <label className="fw-bold">
                      Uploaded Image
                      <span className="text-danger fw-lighter ms-1">*</span>
                    </label>
                    {image ? (
                      <div className="border-1 border rounded-3 position-relative col-sm-6">
                        <img
                          className="w-100"
                          src={`${image}`}
                          alt="Uploaded file"
                        ></img>
                        <button
                          className="btn btn-sm bg-white position-absolute"
                          onClick={() => this.setState({ image: "" })}
                          style={{ top: `2%`, right: `2%` }}
                        >
                          <i className="bi bi-trash text-danger"></i>
                        </button>
                      </div>
                    ) : (
                      <div className="border-1 border rounded-3 position-relative col-sm-6 bg-light-subtle">
                        <a href="#uploadImage">
                          <img
                            className="w-100"
                            src="/defaultImage.png"
                            alt="Default Image"
                          ></img>
                        </a>
                      </div>
                    )}
                  </div>
                </div>

                <div className="mt-5">
                  <b>Personal Information</b>
                  <hr />
                </div>
                <div className="row justify-content-md-start mt-3">
                  <FormFactory
                    schema={schemaPersonalForm1}
                    onChange={this.onChangePersonal.bind(this)}
                  />
                  <span
                    className="d-inline-block col-md-2 col-lg-1"
                    style={{ marginTop: `1rem` }}
                  >
                    <small>
                      Age<span className="text-danger ms-1">*</span>
                    </small>
                    <p
                      className="bg-light-subtle p-2 cursor-pointer text-center fw-bold border border-1 rounded-1"
                      style={{ marginTop: `0.5rem` }}
                    >
                      {age}
                    </p>
                  </span>
                  <FormFactory
                    schema={schemaPersonalForm2}
                    onChange={this.onChangePersonal.bind(this)}
                  />
                </div>

                <div className="row justify-content-md-start mt-3">
                  <div className="mt-4">
                    <b>Present Address</b>
                  </div>
                  <FormFactory
                    schema={schemaPresentAddress}
                    onChange={this.onChangePersonal.bind(this)}
                  />
                </div>
                <div className="row justify-content-md-start mt-3">
                  <div className="col-md-5 d-flex gap-2">
                    <input
                      type="checkbox"
                      onChange={this.toggleCheckbox.bind(this)}
                      className="cursor-pointer"
                    />
                    <p className="m-0 p-0">
                      Permanent Address same as a Present Address
                    </p>
                  </div>
                </div>

                {!isAddressSame ? (
                  <div className="row justify-content-md-start mt-3">
                    <div className="mt-4">
                      <b>Permanent Address</b>
                    </div>
                    <FormFactory
                      schema={schemaPermanentAddress}
                      onChange={this.onChangePersonal.bind(this)}
                    />
                  </div>
                ) : (
                  ""
                )}
                <div className="row justify-content-md-start mt-3">
                  <FormFactory
                    schema={schemaIdForm}
                    onChange={this.onChangePersonal.bind(this)}
                  />
                </div>
                <div className="mt-4">
                  <b>Emergency Contact Person</b>
                  <hr></hr>
                </div>
                <div className="row justify-content-md-start mt-3">
                  <FormFactory
                    schema={schemaContactPerson}
                    onChange={this.onChangePersonal.bind(this)}
                  />
                  <div className="row justify-content-md-start mt-3">
                    <div className="col-md-5 d-flex gap-2">
                      <input
                        type="checkbox"
                        onChange={this.toggleCheckboxContact.bind(this)}
                        className="cursor-pointer"
                      />
                      <p className="m-0 p-0">Same as Applicant's Address</p>
                    </div>
                  </div>
                  {addressSameApplicant ? (
                    ""
                  ) : (
                    <FormFactory
                      schema={schemaContactPersonAddress}
                      onChange={this.onChangePersonal.bind(this)}
                    />
                  )}
                </div>
                <div className="mt-4">
                  <b>Educational Information</b>
                  <hr />
                </div>
                {/* <div className="mt-4">
                  <b>Elementary</b>
                </div>
                <div className="row justify-content-md-start mt-3">
                  <FormFactory
                    schema={schemaElementaryForm}
                    onChange={this.onChangePersonal.bind(this)}
                  />
                </div> */}
                <div className="mt-4">
                  <b>High School</b>
                </div>
                <div className="row justify-content-md-start mt-3">
                  <FormFactory
                    schema={schemaHSForm}
                    onChange={this.onChangePersonal.bind(this)}
                  />
                </div>
                <div className="mt-4">
                  <b>College</b>
                </div>
                <div className="row justify-content-md-start mt-3">
                  <FormFactory
                    schema={schemaColForm}
                    onChange={this.onChangePersonal.bind(this)}
                  />
                </div>

                <div className="row justify-content-md-start mt-3">
                  <div className="col-md-5 d-flex">
                    <InputFactory
                      type="Boolean"
                      field="isFreshGrad"
                      label="Fresh Graduate"
                      className="cursor-pointer"
                      onChange={this.onChangePersonal.bind(this)}
                    />
                  </div>
                </div>
                <div>
                  <RelationForm
                    title="Employment Background"
                    schema={schemaEmployment}
                    objects={employers}
                    onChangeForm={this.presenter.onChangeEmployment}
                    addForm={this.addEmployer}
                    remove={this.removeEmployer}
                  />
                </div>
                <div>
                  <RelationForm
                    title="Character References"
                    schema={schemaCharacterRef}
                    objects={characterref}
                    onChangeForm={this.presenter.onChangecharacteref}
                    addForm={this.addCharacterRef}
                    remove={this.removeCharacterRef}
                  />
                </div>
                <div className="mt-4">
                  <b>School Record</b>
                  <hr />
                </div>
                <div className="mt-3">
                  <div
                    className="bg-light-subtle p-2 position-relative col-lg-4 border border-1 rounded-1 z-3 cursor-pointer"
                    onClick={this.toggleDropdown.bind(this)}
                  >
                    {selectedNames.length === 0
                      ? "Select"
                      : selectedNames.join(", ")}

                    <div
                      className={`bg-white text-start shadow-sm border border-1 position-absolute
                        ${isschoolRecord ? "d-block" : "d-none"}`}
                      style={{ bottom: "-100", cursor: "pointer" }}
                    >
                      <div className="d-flex flex-column z-3">
                        <div className="p-2">
                          <label>
                            <input
                              type="checkbox"
                              name="diploma"
                              title="Diploma"
                              checked={selectedOptions.diploma}
                              onChange={this.handleCheckboxChange}
                            />
                            Diploma
                          </label>
                        </div>
                        <div className="p-2">
                          <label>
                            <input
                              type="checkbox"
                              name="tor"
                              title="TOR"
                              checked={selectedOptions.tor}
                              onChange={this.handleCheckboxChange}
                            />
                            TOR
                          </label>
                        </div>
                        <div className="p-2">
                          <label>
                            <input
                              type="checkbox"
                              name="reportCard"
                              title="Report Card"
                              checked={selectedOptions.reportCard}
                              onChange={this.handleCheckboxChange}
                            />
                            Report Card
                          </label>
                        </div>
                        <div className="p-2">
                          <label>
                            <input
                              type="checkbox"
                              name="graduationCertificate"
                              title="Certificate of Graduation"
                              checked={selectedOptions.graduationCertificate}
                              onChange={this.handleCheckboxChange}
                            />
                            Certificate of Graduation
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="d-flex row justify-content-md-start mt-3">
                  {selectedOptions.diploma && (
                    <div className="col-lg-3 col-md-6">
                      <label>Diploma</label>
                      <InputFactory
                        type="String"
                        _type="File"
                        required
                        className="form-control bg-light-subtle p-2"
                        placeholder="Diploma"
                        field="diploma"
                        onChange={this.onChangePersonal.bind(this)}
                      />

                      {uploadedFiles.diploma && (
                        <p>{uploadedFiles.diploma.name}</p>
                      )}
                    </div>
                  )}
                  {selectedOptions.tor && (
                    <div className="col-lg-3 col-md-6">
                      <label>TOR</label>
                      <InputFactory
                        type="String"
                        _type="File"
                        required
                        className="form-control bg-light-subtle p-2"
                        placeholder="TOR"
                        field="tor"
                        onChange={this.onChangePersonal.bind(this)}
                      />
                      {uploadedFiles.tor && <p>{uploadedFiles.tor.name}</p>}
                    </div>
                  )}
                  {selectedOptions.reportCard && (
                    <div className="col-lg-3 col-md-6">
                      <label>Report Card</label>
                      <InputFactory
                        type="String"
                        _type="File"
                        required
                        className="form-control bg-light-subtle p-2"
                        placeholder="Report Card"
                        field="reportCard"
                        onChange={this.onChangePersonal.bind(this)}
                      />
                      {uploadedFiles.reportCard && (
                        <p>{uploadedFiles.reportCard.name}</p>
                      )}
                    </div>
                  )}
                  {selectedOptions.graduationCertificate && (
                    <div className="col-lg-3 col-md-6">
                      <label>Certificate of Graduation</label>
                      <InputFactory
                        type="String"
                        _type="File"
                        required
                        className="form-control bg-light-subtle p-2"
                        placeholder="Certificate of Graduation"
                        field="graduationCertificate"
                        onChange={this.onChangePersonal.bind(this)}
                      />
                      {uploadedFiles.graduationCertificate && (
                        <p>{uploadedFiles.graduationCertificate.name}</p>
                      )}
                    </div>
                  )}
                </div>
                <div className="mt-4">
                  <b>Upload Documents</b>
                  <hr />
                </div>
                <div className="row justify-content-md-start mt-3">
                  <FormFactory
                    schema={schemaDocForm}
                    onChange={this.onChangePersonal.bind(this)}
                  />
                </div>
                <div className="row justify-content-md-start mt-3">
                  <FormFactory
                    schema={schemaOtherDocs}
                    onChange={this.onChangePersonal.bind(this)}
                  />
                </div>
                <div id="uploadImage" className="mt-4">
                  <hr></hr>
                  <label className="fw-bold">
                    Upload Image
                    <span className="text-danger ms-1 fw-lighter">*</span>
                  </label>
                  <InputFactory
                    type="InputCamera"
                    noCamera={false}
                    saveImage={saveImageUseCase()}
                    saveFile={saveFileUseCase()}
                    onChange={(value) => this.setState({ image: value })}
                    field="image1"
                    required
                  />
                </div>
                {image && (
                  <div className="mt-3">
                    <label className="fw-bold">Attached Image:</label>
                    <ul className="list-group mt-2">
                      <div className="border-1 border rounded-3 position-relative col-lg-2 col-sm-6">
                        <img className="w-100" src={`${image}`}></img>
                        <button
                          className="btn btn-sm bg-white position-absolute"
                          onClick={() => this.setState({ image: "" })}
                          style={{ top: `2%`, right: `2%` }}
                        >
                          <i className="bi bi-trash text-danger"></i>
                        </button>
                      </div>
                    </ul>
                  </div>
                )}
                <div className="d-flex gap-2 mt-4">
                  <button
                    disabled={isSubmitting}
                    type="submit"
                    className="p-2 text-white rounded-1 border-0 fw-bold px-4"
                    style={{
                      backgroundColor: isSubmitting ? `#d182376e` : `#D18237`,
                    }}
                  >
                    {isSubmitting ? "Submitting..." : "Submit Application"}
                  </button>

                  <button
                    className="p-2 fw-bold rounded-1 border-0 px-4"
                    onClick={this.goBack.bind(this)}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(ApplicationFormPage);
